<div class="innerheaderSec">
    <div class="innerheaderTitle" [ngClass]="customClasses">{{title}}</div>
</div>
